export default __webpack_public_path__ + "static/media/lezgin.3d90a39d.jpeg";